<template>
  <CardContainer>
    <div slot="header" style="display: grid; grid-template-columns: 1fr auto;">
      <span>
        <hl-button @click="add" v-if="addRole">
          {{ $t('Common.create') }}
        </hl-button>
      </span>
      <CommonForm @search="formSearch" :form-json="formjson" />
    </div>
    <CommonTable
      ref="table"
      :data="tableData"
      :total="total"
      @change="handleTableChange"
      :operation="operation"
      @operation="handleOperation"
      :table-json="tablejson"
    >
    </CommonTable>

    <PushRecordEdit
      :row="row"
      @refresh="formSearch(cacheData, cachePage)"
      v-if="visible"
      :visible.sync="visible"
    />
  </CardContainer>
</template>

<script>
import formjson from './Model/Formjson.Index'
import tablejson from './Model/Tablejson.Index'
import formTableMixin from '@/mixins/formTableMixin'
import getRoleFromPath from '@/mixins/getRoleFromPath'
import { getRoleByOperationCode } from '@/authorized'

import PushRecordEdit from './PushRecordEdit'
export default {
  mixins: [formTableMixin, getRoleFromPath],
  components: {
    PushRecordEdit
  },
  data() {
    return {
      formjson,
      tablejson,
      operation: [
        {
          name: this.$t('Common.delete'),
          icon: 'icon-del_16',
          type: 'delete',
          hide: () => {
            return !this.deleteRole
          }
        }
      ],
      queryApi: this.$api.message.push_record_list,
      row: {},
      visible: false
    }
  },
  computed: {
    roleChildList() {
      return this.role.childList
    },
    // 新增
    addRole() {
      let val = getRoleByOperationCode(this.roleChildList, 'add')
      return val ? val.isPermission == 'Y' : false
    },
    // 删除
    deleteRole() {
      let val = getRoleByOperationCode(this.roleChildList, 'del')
      return val ? val.isPermission == 'Y' : false
    }
  },
  methods: {
    formSearch(data, pageObj) {
      if (!data) {
        data = this.cacheData
      }
      data = {
        ...data
      }
      this.search(data, pageObj, this.queryApi)
    },
    add() {
      this.row = {}
      this.visible = true
    },
    handleDel(row) {
      this.$confirm(`${this.$t('Common.operationTips')}`, `${this.$t('Common.tips')}`, {
        confirmButtonText: `${this.$t('Common.confirm')}`,
        cancelButtonText: `${this.$t('Common.cancel')}`,
        type: 'warning'
      })
        .then(() => {
          let params = {
            id: row.id
          }
          this.$ajax
            .get(this.$api.message.push_record_delete, params)
            .then(() => {
              this.$message.success(`${this.$t('Common.delSuccess')}`)
              this.formSearch()
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    handleOperation(data) {
      const { type, row } = data
      switch (type) {
        case 'delete':
          this.handleDel(row)
          break
      }
    }
  }
}
</script>
